<template>
  <div
    v-if="loading"
    class="clearfix"
  >
    <b-spinner
      class="float-right"
      label="Floated Right"
    />
  </div>
  <div v-else>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <app-collapse type="margin">
          <app-collapse-item
            v-if="verificarPermissao('ROLE_AGREGADO_CONSULTAR')"
            title="Informações Pessoais"
          >
            <FormAggregateInfoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_TIPO_REGISTRO_CONSULTAR')"
            title="Tipo de Registro"
          >
            <FormPersonalRegistryTypeVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_SITUACAO_REGISTRO_CONSULTAR')"
            title="Situação"
          >
            <FormAggregateSituationVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_FAIXA_CONTRIBUICAO_REGISTRO_CONSULTAR')"
            title="Faixa de Contribuição"
          >
            <FormAggregateFaixaContribuicao />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')"
            title="Documentações"
          >
            <FormAggregateDocumentsVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_ENDERECO_CONSULTAR')"
            title="Endereços"
          >
            <FormAggregateEnderecosVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_FONE_CONSULTAR')"
            title="Fones"
          >
            <FormAggregateFoneVue />
          </app-collapse-item>

          <app-collapse-item title="Assinatura">
            <FormDigitalSignatureVue
              store-name="aggregatesAdministrativeModule"
              object-name="fullAggregate"
              action-name="editAggregateDadosPessoais"
              prepare-action-name="prepareToEditFullAggregate"
            />
          </app-collapse-item>
        </app-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { verificarPermissao } from '@/auth/utils'
import FormDigitalSignatureVue from '../../../associantes/forms/personal/FormDigitalSignature.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    FormAggregateInfoVue: () => import('./FormAggregateInfo.vue'),
    FormAggregateDocumentsVue: () => import('./FormAggregateDocuments.vue'),
    FormAggregateSituationVue: () => import('./FormAggregateSituation.vue'),
    FormAggregateEnderecosVue: () => import('./FormAggregateEnderecos.vue'),
    FormAggregateFoneVue: () => import('./FormAggregateFone.vue'),
    FormPersonalRegistryTypeVue: () => import('./FormAggregateTipoRegistro.vue'),
    FormAggregateFaixaContribuicao: () => import('./FormAggregateFaixaContribuicao.vue'),
    FormDigitalSignatureVue,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      verificarPermissao,
      collapseType: 'default',
    }
  },
}
</script>
